//Get Region
export const GET_CONTINENT_REGION = "GET_CONTINENT_REGION";

//Insert Region
export const INSERT_CONTINENT_REGION = "INSERT_CONTINENT_REGION";

//Update Region
export const UPDATE_CONTINENT_REGION = "UPDATE_CONTINENT_REGION";

//Delete Region
export const DELETE_CONTINENT_REGION = "DELETE_CONTINENT_REGION";

//Insert Open Dialog
export const OPEN_CONTINENT_REGION_DIALOG = "OPEN_CONTINENT_REGION_DIALOG";

//Close Dialog
export const CLOSE_CONTINENT_REGION_DIALOG = "CLOSE_CONTINENT_REGION_DIALOG";

//toast
export const OPEN_CONTINENT_REGION_TOAST = "OPEN_CONTINENT_REGION_TOAST";
export const CLOSE_CONTINENT_REGION_TOAST = "CLOSE_CONTINENT_REGION_TOAST";
